import { Component, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
    selector: "app-form-footer",
    imports: [CommonModule],
    templateUrl: "./form-footer.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./form-footer.component.css"]
})
export class FormFooterComponent {}
